$.getJSON('/cart.js', function(cart) {
	var bundleParents = [];
	jQuery.each(cart.items, function(index, item) {
		jQuery.each(item.properties, function(key, value) {
			if ( key == 'ParentSheet' || key == 'ParentBundle' ) {
				bundleParents.push(value);
			}
		});
	});
	jQuery.each(cart.items, function(index, item) {
		jQuery.each(item.properties, function(key, value) {
			if ( key == 'Bundle' || key == 'SheetSet' ) {
				if ( bundleParents.indexOf(value) == -1 ) {
					jQuery.ajax({
						type: 'POST',
						url: '/cart/change.js',
						dataType: 'json',
						data: {
							id: item.key,
							quantity: 0,
						},
						async: false,
						beforeSend: function(data) {
						},
						success: function(data) {
						}
					});
				} else {
				}
			}
		});
	});
});

